var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-box",staticStyle:{"min-height":"92.5vh"}},[_c('campus-card',{attrs:{"selectable":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }